// Componente de ruta pública para la aplicación Amarsi Control Panel
// Controla el acceso a rutas públicas (como login) para usuarios ya autenticados
// Redirige al home-private si el usuario ya está autenticado, o a la ruta original si existía

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

/**
 * Componente PublicRoute
 * 
 * Protege rutas públicas para usuarios ya autenticados
 * Redirige al home-private si el usuario ya está autenticado
 * O a la ruta original si fue redirigido desde una ruta protegida
 * 
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Componentes hijos a renderizar si no está autenticado
 * @param {string} props.redirectTo - Ruta de redirección si está autenticado (default: "/")
 */
const PublicRoute = ({ 
  children, 
  redirectTo = '/' 
}) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Muestra spinner mientras se verifica el estado de autenticación
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="lg" color="primary" className="mb-4" />
          <p className="text-gray-600">Hagamos juntos una plataforma más segura, reporta o denuncia los malos comportamientos ❤️‍🩹</p>
        </div>
      </div>
    );
  }

  // Si ya está autenticado, redirige a la ruta original o al home-private
  if (isAuthenticated) {
    // Verificamos si hay una ruta original a la que volver
    const from = location.state?.from?.pathname || redirectTo;
    return <Navigate to={from} replace />;
  }

  // Si no está autenticado, renderiza los componentes hijos
  return <>{children}</>;
};

export default PublicRoute;
